// Generated by Melange

import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Buhta_cabinet__Date from "../../util/Date.js";
import * as Buhta_cabinet__Timestamp from "../../util/Timestamp.js";
import * as Buhta_components__Text from "../../../../../packages/components/src/html/Text.js";
import * as DateTime from "../../../../../packages/util/lib/DateTime.js";
import * as StaticAsset from "../../../../../packages/util/lib/StaticAsset.js";
import * as Stdlib__List from "melange/list.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function SignDocumentInfo(Props) {
  let doc = Props.doc;
  let participant = Props.participant;
  const sender = Stdlib__List.find((function (p) {
    return p["type'"] === /* DOCUMENT_PARTICIPANT_TYPE_SENDER */ 1;
  }), doc.participants);
  const receiver = Stdlib__List.find((function (p) {
    return p["type'"] === /* DOCUMENT_PARTICIPANT_TYPE_RECIPIENT */ 2;
  }), doc.participants);
  const signerTypeStr = function (participant) {
    const match = participant.signer_type;
    switch (match) {
      case /* SIGNER_ENTITY_TYPE_UNSPECIFIED */ 0 :
        return "Неизвестный тип";
      case /* SIGNER_ENTITY_TYPE_INDIVIDUAL */ 1 :
        return "ИИН";
      case /* SIGNER_ENTITY_TYPE_ORGANIZATION */ 2 :
        return "БИН";
    }
  };
  const match = sender.sign_status;
  const match$1 = receiver.sign_status;
  let generalStatus;
  let exit = 0;
  let exit$1 = 0;
  switch (match) {
    case /* DOCUMENT_PARTICIPANT_SIGN_STATUS_UNSPECIFIED */ 0 :
    case /* DOCUMENT_PARTICIPANT_SIGN_STATUS_PENDING */ 1 :
      exit$1 = 2;
      break;
    case /* DOCUMENT_PARTICIPANT_SIGN_STATUS_SIGNED */ 2 :
      let exit$2 = 0;
      switch (match$1) {
        case /* DOCUMENT_PARTICIPANT_SIGN_STATUS_UNSPECIFIED */ 0 :
        case /* DOCUMENT_PARTICIPANT_SIGN_STATUS_PENDING */ 1 :
          exit$2 = 3;
          break;
        case /* DOCUMENT_PARTICIPANT_SIGN_STATUS_SIGNED */ 2 :
          generalStatus = JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("img", {
                alt: "done",
                src: StaticAsset.src("/static/icons/done-16.svg")
              }),
              JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                className: "text-success",
                children: "Подписан обеими сторонами"
              })
            ],
            className: "flex gap-1"
          });
          break;
      }
      if (exit$2 === 3) {
        generalStatus = JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("img", {
              alt: "sign",
              src: StaticAsset.src("/static/icons/sign-gray-16.svg")
            }),
            JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
              className: "text-asphalt",
              children: "Ожидаем подпись получателя"
            })
          ],
          className: "flex gap-1"
        });
      }
      break;
  }
  if (exit$1 === 2) {
    switch (match$1) {
      case /* DOCUMENT_PARTICIPANT_SIGN_STATUS_UNSPECIFIED */ 0 :
      case /* DOCUMENT_PARTICIPANT_SIGN_STATUS_PENDING */ 1 :
        exit = 1;
        break;
      case /* DOCUMENT_PARTICIPANT_SIGN_STATUS_SIGNED */ 2 :
        generalStatus = JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("img", {
              alt: "sign",
              src: StaticAsset.src("/static/icons/sign-gray-16.svg")
            }),
            JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
              className: "text-asphalt",
              children: "Ожидаем подпись отправителя"
            })
          ],
          className: "flex gap-1"
        });
        break;
    }
  }
  if (exit === 1) {
    generalStatus = JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
      className: "text-asphalt",
      children: "Не подписан с обеих сторон"
    });
  }
  const date = doc.document_date;
  const name = sender.name;
  const tin = sender.tin;
  const match$2 = sender.sign_status;
  let tmp;
  let exit$3 = 0;
  switch (match$2) {
    case /* DOCUMENT_PARTICIPANT_SIGN_STATUS_UNSPECIFIED */ 0 :
    case /* DOCUMENT_PARTICIPANT_SIGN_STATUS_PENDING */ 1 :
      exit$3 = 1;
      break;
    case /* DOCUMENT_PARTICIPANT_SIGN_STATUS_SIGNED */ 2 :
      const tin$1 = sender.tin;
      tmp = JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
            className: "text-gray-medium",
            children: "Подписант"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                children: Belt__Belt_Option.getWithDefault(sender.name, "")
              }),
              JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                className: "text-asphalt",
                children: signerTypeStr(sender) + (" " + (
                  tin$1 !== undefined ? tin$1 : ""
                ))
              })
            ]
          }),
          JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
            className: "text-gray-medium",
            children: "Подпись"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("img", {
                    alt: "done",
                    src: StaticAsset.src("/static/icons/done-16.svg")
                  }),
                  JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                    className: "text-success",
                    children: "Подписано"
                  })
                ],
                className: "flex gap-1"
              }),
              JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                className: "text-asphalt",
                children: DateTime.toLocalFormat(Buhta_cabinet__Timestamp.toDateTime(Belt__Belt_Option.getWithDefault(sender.sign_accept_time, Buhta_cabinet__Timestamp.fromString("01.01.2000"))))
              })
            ]
          })
        ],
        className: "mt-4 grid grid-cols-[110px,_max-content] gap-2"
      });
      break;
  }
  if (exit$3 === 1) {
    tmp = JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx("img", {
          alt: "sign",
          src: StaticAsset.src("/static/icons/sign-blue-16.svg")
        }),
        JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
          className: "text-secondary",
          children: sender.tin === participant.tin ? "Ожидаем подпись с вашей стороны" : "Ожидаем подпись отправителя"
        })
      ],
      className: "mt-4 flex gap-1"
    });
  }
  const tin$2 = receiver.tin;
  const match$3 = receiver.sign_status;
  let tmp$1;
  let exit$4 = 0;
  switch (match$3) {
    case /* DOCUMENT_PARTICIPANT_SIGN_STATUS_UNSPECIFIED */ 0 :
    case /* DOCUMENT_PARTICIPANT_SIGN_STATUS_PENDING */ 1 :
      exit$4 = 1;
      break;
    case /* DOCUMENT_PARTICIPANT_SIGN_STATUS_SIGNED */ 2 :
      const tin$3 = receiver.tin;
      tmp$1 = JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
            className: "text-gray-medium",
            children: "Подписант"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                className: "text-asphalt",
                children: Belt__Belt_Option.getWithDefault(receiver.name, "")
              }),
              JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                className: "text-asphalt",
                children: signerTypeStr(receiver) + (" " + (
                  tin$3 !== undefined ? tin$3 : ""
                ))
              })
            ]
          }),
          JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
            className: "text-gray-medium",
            children: "Подпись"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("img", {
                    alt: "done",
                    src: StaticAsset.src("/static/icons/done-16.svg")
                  }),
                  JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                    className: "text-success",
                    children: "Подписано"
                  })
                ],
                className: "flex gap-1"
              }),
              JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                className: "text-asphalt",
                children: DateTime.toLocalFormat(Buhta_cabinet__Timestamp.toDateTime(Belt__Belt_Option.getWithDefault(receiver.sign_accept_time, Buhta_cabinet__Timestamp.fromString("01.01.2000"))))
              })
            ]
          })
        ],
        className: "mt-4 grid grid-cols-[110px,_max-content] gap-2"
      });
      break;
  }
  if (exit$4 === 1) {
    tmp$1 = JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx("img", {
          alt: "sign",
          src: StaticAsset.src("/static/icons/sign-blue-16.svg")
        }),
        JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
          className: "text-secondary",
          children: receiver.tin === participant.tin ? "Ожидаем подпись с вашей стороны" : "Ожидаем подпись получателя"
        })
      ],
      className: "mt-4 flex gap-1"
    });
  }
  return JsxRuntime.jsxs(React.Fragment, {
    children: [
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("img", {
            alt: "docs",
            src: StaticAsset.src("/static/icons/docs-gray-16.svg")
          }),
          JsxRuntime.jsx(Buhta_components__Text.Label.make, {
            className: "text-default-gray",
            children: "Основная информация"
          })
        ],
        className: "flex gap-2"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
            className: "text-gray-medium",
            children: "Номер документа"
          }),
          JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
            children: doc.document_num
          }),
          JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
            className: "text-gray-medium",
            children: "Статус"
          }),
          generalStatus,
          JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
            className: "text-gray-medium",
            children: "Рег. номер"
          }),
          JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
            children: doc.register_num
          }),
          JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
            className: "text-gray-medium",
            children: "Дата документа"
          }),
          JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
            children: date !== undefined ? Buhta_cabinet__Date.toString(date) : ""
          })
        ],
        className: "mt-4 grid grid-cols-[110px,_max-content] gap-2"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("img", {
            alt: "send",
            src: StaticAsset.src("/static/icons/send-gray-16.svg")
          }),
          JsxRuntime.jsx(Buhta_components__Text.Label.make, {
            className: "text-default-gray",
            children: "Отправитель"
          })
        ],
        className: "flex gap-2 mt-10"
      }),
      JsxRuntime.jsx(Buhta_components__Text.H6.make, {
        className: "mt-2",
        children: name !== undefined ? name : ""
      }),
      JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
        className: "text-asphalt",
        children: signerTypeStr(sender) + (" " + (
          tin !== undefined ? tin : ""
        ))
      }),
      tmp,
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("img", {
            alt: "send",
            src: StaticAsset.src("/static/icons/receive-gray-16.svg")
          }),
          JsxRuntime.jsx(Buhta_components__Text.Label.make, {
            className: "text-default-gray",
            children: "Получатель"
          })
        ],
        className: "flex gap-2 mt-10"
      }),
      JsxRuntime.jsx(Buhta_components__Text.H6.make, {
        className: "mt-2",
        children: Belt__Belt_Option.getWithDefault(receiver.name, "")
      }),
      JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
        className: "text-asphalt",
        children: signerTypeStr(receiver) + (" " + (
          tin$2 !== undefined ? tin$2 : ""
        ))
      }),
      tmp$1
    ]
  });
}

const make = SignDocumentInfo;

export {
  make,
}
/* Buhta_cabinet__Date Not a pure module */
